import styled from '@emotion/styled';
import { Form } from 'antd';

export const StyledFormItem = styled(Form.Item)`
  margin-bottom: 12px;
  width: 100%;
  font-size: 14px;
`;
